<div class="fi-status-avatar">
    <fi-icon
        [size]="size"
        [variation]="'custom'"
        [svgName]="avatarType"
    ></fi-icon>
</div>
